document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-main-nav]');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    nav?.classList.toggle('is-open', !expanded);
  }

  const quantityButton = event.target.closest('[data-quantity-change]');
  if (quantityButton) {
    const input = quantityButton.closest('[data-quantity-control]')?.querySelector('input');
    if (!input) return;
    const change = Number(quantityButton.dataset.quantityChange);
    const min = Number(input.min || 1);
    const max = Number(input.max || 9999);
    input.value = String(Math.min(max, Math.max(min, Number(input.value || min) + change)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const dismiss = event.target.closest('[data-dismiss]');
  if (dismiss) dismiss.closest('[data-status-message]')?.remove();
});

function formatProductMoney(cents) {
  if (window.Shopify?.formatMoney && window.Shopify?.money_format) {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }
  const currency = window.Shopify?.currency?.active;
  if (currency) {
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency,
    }).format(cents / 100);
  }
  return (cents / 100).toFixed(2);
}

function updateProductVariant(form, variant) {
  if (!form || !variant) return;
  const idInput = form.querySelector('[data-variant-id]');
  const submit = form.querySelector('[type="submit"]');
  const price = form.closest('.product-info')?.querySelector('[data-product-price]');
  const compare = form.closest('.product-info')?.querySelector('[data-product-compare]');
  const paymentButton = form.querySelector('.shopify-payment-button');
  if (idInput) idInput.value = variant.id;
  if (submit) {
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? submit.dataset.addLabel : submit.dataset.soldLabel;
  }
  if (paymentButton) paymentButton.hidden = !variant.available;
  if (price) price.textContent = formatProductMoney(variant.price);
  if (compare) {
    compare.textContent = variant.compare_at_price > variant.price ? formatProductMoney(variant.compare_at_price) : '';
    compare.hidden = !(variant.compare_at_price > variant.price);
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url);
}

document.addEventListener('click', (event) => {
  const choice = event.target.closest('[data-variant-choice]');
  if (!choice) return;
  const form = choice.closest('[data-product-form]');
  const variantsNode = form?.querySelector('[data-product-variants]');
  if (!form || !variantsNode) return;
  const variants = JSON.parse(variantsNode.textContent);
  const optionValue = choice.dataset.optionValue;
  const variant = variants.find((item) => item.options.includes(optionValue) && item.available);
  if (!variant) return;
  form.querySelectorAll('[data-variant-choice]').forEach((button) => {
    const selected = button === choice;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });
  updateProductVariant(form, variant);
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-product-option]')) {
    const select = event.target;
    const form = select.closest('[data-product-form]');
    const variantsNode = form?.querySelector('[data-product-variants]');
    if (!form || !variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const options = [...form.querySelectorAll('[data-product-option]')].map((input) => input.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
    updateProductVariant(form, variant);
  }

  if (event.target.matches('[data-sort-select]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  }
});
